import { createApp } from "vue"
import app from "@/app.vue"
import router from "@/router/index.js"

const vue_app = createApp(app)
vue_app.use(router)
vue_app.mount("#app")
